/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import CheckBoxRender from '../gridComponents/CheckBoxRender';
import { CALCULATED_URA_TABLEHAD } from '../gridComponents/tableHead';

const CalculatedURATable = ({
  showFullScreen = true,
  fullScreen,
  setFullScreen,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const calculatedURATableData = useSelector(
    (state) => state.sharedState.URASearchReducer.childGridDetailListTableData
  );

  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);

  useEffect(() => {
    resetFilters();
  }, [gridApi, calculatedURATableData]);

  return (
    <>
      <TableFilterHeader
        gridApi={gridApi}
        columnApi={columnApi}
        childRef={childRef}
        showFullScreen={showFullScreen}
        applyFilter={applyFilter}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        showExport={true}
        showHistory={false}
        fileName={'NDC Details'}
        resetFilterFunc={resetFilters}
        className="mt-2 mb-1 border-bottom"
      />
      <div className="table-container eightRecords">
        <Grid
          ref={childRef}
          gridHeight={fullScreen ? '100vh' : 200}
          rowData={calculatedURATableData ?? []}
          columnDefs={CALCULATED_URA_TABLEHAD}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          onFilterChanged={(e) => {
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
          frameworkComponents={{
            DefPaperIndCheckBoxRender: CheckBoxRender,
          }}
        />
      </div>
    </>
  );
};

export default CalculatedURATable;
